"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WeakCache = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = require("lodash");

var _properties = require("./utils/properties");

var privates = new WeakMap();

var createMap = function createMap() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if ((0, _lodash.isObject)(obj)) obj = (0, _lodash.toPairs)(obj);
  return new Map(obj);
};

var WeakCache =
/*#__PURE__*/
function () {
  function WeakCache() {
    var _this = this;

    var init = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, WeakCache);

    this.hide = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _properties.hide.apply(void 0, [_this].concat(args));
    };

    this.hideGetter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _properties.hideGetter.apply(void 0, [_this].concat(args));
    };

    var anchor = this;

    this.clear = function (init) {
      privates["delete"](anchor);
      privates.set(anchor, createMap(init));
      return _this;
    };

    this.hideGetter('_wm', function () {
      if (privates.has(anchor)) {
        return privates.get(anchor);
      }

      return privates.set(anchor, createMap(init)).get(anchor);
    });
    this.clear(init);

    this.write = function (k, v) {
      return _this.set(k, v).get(k);
    };
  }

  (0, _createClass2["default"])(WeakCache, [{
    key: "fetch",
    value: function fetch(k, defaultValue) {
      if (this.has(k)) {
        return this.get(k);
      } else {
        this.set(k, typeof defaultValue === 'function' ? defaultValue(k) : defaultValue);
        return this.get(k);
      }
    }
  }, {
    key: "delete",
    value: function _delete(k) {
      return this._wm["delete"](k);
    }
  }, {
    key: "get",
    value: function get(k) {
      return this._wm.get(k);
    }
  }, {
    key: "has",
    value: function has(k) {
      return this._wm.has(k);
    }
  }, {
    key: "set",
    value: function set(k, v) {
      this._wm.set(k, v);

      return this;
    }
  }]);
  return WeakCache;
}();

exports.WeakCache = WeakCache;
var _default = WeakCache;
exports["default"] = _default;